// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3-Zc4","header":"PatientQuestionnaire_header__EhxEc","info":"PatientQuestionnaire_info__2eD8t"};